import React, { useEffect } from "react";
import "../styles/global.css";

const PaymentSuccess = () => {

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const orderId = params.get("order_id");

    console.log("Order ID:", orderId);

    // 👉 Call backend to verify payment
    fetch(`http://localhost:8000/api/verify-order/${orderId}`)
      .then(res => res.json())
      .then(data => {
        console.log("Verify:", data);
      });

  }, []);

  return <h2>Payment Completed ✅</h2>;
};

export default PaymentSuccess;